import { render, staticRenderFns } from "./OverlayForms.vue?vue&type=template&id=128d1c42"
import script from "./OverlayForms.vue?vue&type=script&lang=js"
export * from "./OverlayForms.vue?vue&type=script&lang=js"
import style0 from "./OverlayForms.vue?vue&type=style&index=0&id=128d1c42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports